import { init as initApi, search as searchApi, print as printApi, dataAnalysisPrint as dataAnalysisPrintApi } from "../../service/PrintServce";
export const INIT_SUCCESS = "PRINGING_INIT_SUCCESS";
export const INIT_FAIL = "PRINTING_INIT_FAIL";
export const SEARCH_SUCCESS = "PRINTING_SEARCH_SUCCESS";
export const SEARCH_FAIL = "PRINTING_SEARCH_FAIL";
export const PRINTING_SUCCESS = "PRINTING_SUCCESS";
export const PRINTING_FAIL = "PRINTING_FAIL";
export const PRINTING_RESET = "PRINTING_RESET";

export const init = () => dispatch => {
  initApi().then(response => {
    if (response.message) {
      dispatch({ 
        type: INIT_FAIL, 
        payload: `メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`
      });
    }
    dispatch({
      type: INIT_SUCCESS,
      payload: {
        evaluationList: response.evaluationList,
        evaluationTerm: response.evaluationTerm,
        printTarget: response.printingTarget
      }
    });
  });
};
export const search = params => dispatch => {
  searchApi(params).then(response => {
    if (response.message) {
      dispatch({ type: SEARCH_FAIL, payload: { message: response.message, code: response.messageCode } });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    } else {
      const rows = response.student.map((student, index) => {
        return {
          id: index,
          serialNumber: student.serialNumber,
          grade: student.grade,
          class: student.classNumber,
          number: student.number,
          name: student.name
        };
      });
      dispatch({
        type: SEARCH_SUCCESS,
        payload: { rows: rows }
      });
    }
  });
};
export const print = params => dispatch => {
  printApi(params).then(response => {
    if (response.message) {
      dispatch({ type: PRINTING_FAIL, payload: { message: response.message, code: response.messageCode } });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    } else {
      dispatch({
        type: PRINTING_SUCCESS, 
        payload: { 
          downloadLink: response.urlPath, 
        }
      });
    }
  })
};

export const dataAnalysisPrint = params => dispatch => {
  dataAnalysisPrintApi(params).then(response => {
    if (response.message) {
      dispatch({ type: PRINTING_FAIL, payload: { message: response.message, code: response.messageCode } });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    } else {
      dispatch({
        type: PRINTING_SUCCESS, 
        payload: { 
          downloadLink: response.urlPath, 
        }
      });
    }
  })
};